import { AppStoreContextWrapper } from "@common/contexts";
import { AppStore } from "@common/stores";
import { useContext } from "react";

export const useApp = () => useContext<AppStore>(AppStoreContextWrapper.get());
